import buildSpotsList from './spots-list';

export default function setMarkersFilteringOn(
  data,
  allMarkers,
  buildList,
  { searchedPlaceLat, searchedPlaceLng }
) {
  const showAllMarkersWhenNoCategoryIsSelected = () => {
    const allCategoriesVisibleCheckboxes = document.querySelectorAll(
      '[data-module="Locator__Category"]'
    );
    const arrVisibleCategories = [];

    allCategoriesVisibleCheckboxes.forEach(checkbox => arrVisibleCategories.push(checkbox.checked));

    if (arrVisibleCategories.every(item => item === false)) {
      allMarkers.forEach(marker => {
        marker.setVisible(true);
      });

      if (buildList) {
        buildSpotsList(data, false, false, allMarkers, searchedPlaceLat, searchedPlaceLng);
      }
    }
  };

  const showMarkersBySelectedCategory = () => {
    const visibleCategories = [];

    document.querySelectorAll('[data-module="Locator__Category"]').forEach(checkbox => {
      const isVisible = checkbox.checked;
      if (isVisible) {
        visibleCategories.push(checkbox.value);
      }
    });

    allMarkers.forEach(marker => {
      const hasActiveCategory = marker.category.some(x => visibleCategories.includes(x));
      marker.setVisible(hasActiveCategory);
    });

    const filteredData = { ...data };
    filteredData.features = filteredData.features.filter(x =>
      visibleCategories.includes(x.categoryId)
    );

    if (buildList) {
      buildSpotsList(filteredData, false, false, allMarkers, searchedPlaceLat, searchedPlaceLng);
      showAllMarkersWhenNoCategoryIsSelected();
    }
  };

  setTimeout(() => {
    const locationCategories = document.querySelectorAll('[data-module="Locator__Category"]');
    locationCategories.forEach(locationCategory => {
      locationCategory.addEventListener('change', () => {
        showMarkersBySelectedCategory();

        const isChecked = locationCategory.checked;
        const collapse = locationCategory.parentNode.querySelector('[data-toggle="collapse"]');
        if (collapse) {
          const collapsibleId = collapse.getAttribute('href');

          if (!isChecked) {
            document.querySelector(collapsibleId).classList.remove('in');
            locationCategory.parentNode
              .querySelector('[data-toggle="collapse"]')
              .classList.add('collapsed');
          }
        }
      });
    });
  }, 1000);
}
